const IRRtoIRT = (price: string | number): number => {
  return Math.floor(Number(price) / 10);
};
export default IRRtoIRT;
